import { InvisibleSmartCaptchaProps, SmartCaptcha } from '@yandex/smart-captcha';
import { memo } from 'react';

interface YandexCaptchaProps extends Omit<InvisibleSmartCaptchaProps, 'sitekey'> {
  resetCaptcha?: number;
}

export const YandexCaptcha = memo((props: YandexCaptchaProps) => {
  const { onSuccess, resetCaptcha } = props;

  return (
    <SmartCaptcha
      sitekey="ysc1_rD6Ngwon0DtlMQUaREFL1Z2alAgA0dRcJ2tqklGN55a75b6e"
      onSuccess={onSuccess}
      key={resetCaptcha}
    />
  );
});
